export default __webpack_public_path__ + "static/media/exemplo-documentacao2.cd5246b4.png";